import { _IMAPI } from "../assets/js/imapi";



const getProfileMenu = (params) => {

    return new Promise((resolve, reject) => {
        _IMAPI._POST(_IMAPI.getService("profile-menu"), {}, params, (res) => {

            resolve(res);

        }, (err) => {
            let data = err.response ? err.response.data : err;
            reject(data.message)

        })
    })
}

const sendRefundOTPDMT = (params) => {

    return new Promise((resolve, reject) => {
        _IMAPI._POST(_IMAPI.getService("send-mpin-otp"), {}, params, (res) => {

            resolve(res);

        }, (err) => {
            let data = err.response ? err.response.data : err;
            reject(data.message)

        })
    })
}

const verifyRefundOTPDMT = (params) => {

    return new Promise((resolve, reject) => {
        _IMAPI._POST(_IMAPI.getService("verify-mpin-otp"), {}, params, (res) => {

            resolve(res);

        }, (err) => {
            let data = err.response ? err.response.data : err;
            reject(data.message)

        })
    })
}

const billAvenueRegisterComplain = (params) => {

    return new Promise((resolve, reject) => {
        _IMAPI._POST(_IMAPI.getService("avenue-bbps-complain"), {}, params, (res) => {

            resolve(res);

        }, (err) => {
            let data = err.response ? err.response.data : err;
            reject(data.message)

        })
    })
}

const billAvenueTrackComplaint = (params) => {

    return new Promise((resolve, reject) => {
        _IMAPI._POST(_IMAPI.getService("avenue-bbps-track-complaint"), {}, params, (res) => {

            resolve(res);

        }, (err) => {
            let data = err.response ? err.response.data : err;
            reject(data.message)

        })
    })
}

const getBillavenueComplaintOptions = (params) => {

    return new Promise((resolve, reject) => {

        _IMAPI._GET(_IMAPI.getService("billavenue-complaint-disposition"), {}, params, (res) => {

            resolve(res)
        }, err => {

            let error = err.response ? err.response.data : err;
            reject(error)

        });

    })

}



const sendRefundPPIDMTOTP = (params) => {

    return new Promise((resolve, reject) => {
        _IMAPI._POST(_IMAPI.getService("ppidmt-send-refund-otp"), {}, params, (res) => {

            resolve(res);

        }, (err) => {
            let data = err.response ? err.response.data : err;
            reject(data.message)

        })
    })
}

const verifyRefunPPIDMTdOTP = (params) => {

    return new Promise((resolve, reject) => {
        _IMAPI._POST(_IMAPI.getService("ppidmt-verify-refund-otp"), {}, params, (res) => {

            resolve(res);

        }, (err) => {
            let data = err.response ? err.response.data : err;
            reject(data.message)

        })
    })
}





export {
    getProfileMenu,
    sendRefundOTPDMT,
    verifyRefundOTPDMT,
    billAvenueTrackComplaint,
    getBillavenueComplaintOptions,
    billAvenueRegisterComplain,
    sendRefundPPIDMTOTP,
    verifyRefunPPIDMTdOTP
}